import { ConfigFn } from '@config/types'

const config = (({ staticAssetPageUrl, staticPageUrlSuffix }) =>
  ({
    widgetUrl: `${staticAssetPageUrl}/riddle${staticPageUrlSuffix}`,
  }) as const) satisfies ConfigFn

export default config
